export default __webpack_public_path__ + "static/media/download_EDO project ‘wondere wereld'_doelenlijst.0a3d10d3.pdf";